import { ILoginParams } from '../types/ILoginParams';
import { ISessionInfo } from '../types/ISessionInfo';
import { Request } from './Request';

export class InitializeServerWithExternalUserRequest extends Request<ILoginParams, ISessionInfo> {
  constructor(params: ILoginParams) {
    super('initializeServerWithExternalUser', params);
  }
}
